<script>
  import formasPagamento from '~js/formas-pagamento';
  import 'vue-strap/dist/vue-strap-lang';
  import { datepicker } from 'vue-strap';
  
  export default {
    components: { datepicker },
    props: {
      solicitacao: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        formasPagamento: formasPagamento.slice(0, -1),
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      validar(valido) {
        if (!valido) throw new Error("validacao com erro");
        
        return this.$validator.validateAll();
      },
      arrayRemove(arr, value) {
         return arr.filter(function(ele){
             return ele.id != value;
         });
      },
      aplicaconfiguracaoweb() {
        if (this.configuracao) {
          // Visualiza��o Formas Pagamento
          if (!this.configuracao.solAdiantamentoDeposito)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 0);

          if (!this.configuracao.solAdiantamentoCheque)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 1);

          if (!this.configuracao.solAdiantamentoOP)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 2);

          if (!this.configuracao.solAdiantamentoBoleto)
            this.formasPagamento = this.arrayRemove(this.formasPagamento, 3);
        }
      },
    },
    mounted() {
      //$('.datepicker input').attr('readonly', '');
      this.aplicaconfiguracaoweb();
    }
  }
</script>

<template>
  <div>

    <div class="row">
      <div class="col-lg-6" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
        <div class="form-group required" :class="{'has-error': errors.has('dataPagamento')}">
          <label class="control-label">Data para pagamento</label>

          <datepicker
            v-model="solicitacao.dataPagamento"
            format="dd/MM/yyyy"
            placeholder="  /  /     "
            lang="pt-BR"
            data-vv-name="dataPagamento"
            data-vv-as="data para pagamento"
            v-validate="'required|date_format:DD/MM/YYYY'">
          </datepicker>

          <p class="text-danger" v-show="errors.has('dataPagamento')">{{ errors.first('dataPagamento') }}</p>
        </div>
      </div>

      <div :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-6' : 'col-lg-12']">
        <div class="form-group required" :class="{'has-error': errors.has('formaPagamento')}">
          <label class="control-label" for="forma-pagamento">Forma de pagamento</label>

          <select
              class="form-control"
              id="forma-pagamento"
              v-model="solicitacao.formaPagamento"
              data-vv-name="formaPagamento"
              data-vv-as="forma de pagamento"
              v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="formaPagamento.id" v-for="formaPagamento in formasPagamento">{{ formaPagamento.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('formaPagamento')">{{ errors.first('formaPagamento') }}</p>
        </div>
      </div>
    </div>
    
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-adiantamento/componentes/compartilhado/FormDadosPagamento.vue